import React, { FC } from 'react';
import { FormikHelpers } from 'formik';
import Products from '../../../../../library/inputs/products/Products';
import { Product } from '../../../../../../models/form/product';
import Feedback from '../../../../../library/inputs/feedback/Feedback';
import _ from 'lodash';

interface Props {
  id: string;
  value: Array<{ id: string; quantity: number }>;
  products: Array<Product> | undefined;
  fieldProperties: any[];
  setFieldTouched: FormikHelpers<string>['setFieldTouched'];
  setFieldValue: FormikHelpers<string>['setFieldValue'];
  readOnlyMode: boolean;
  culture?: string;
  touched: any;
  errors: any;
}

const ProductsField: FC<Props> = ({
  id,
  value,
  products,
  fieldProperties,
  setFieldTouched,
  setFieldValue,
  readOnlyMode,
  culture,
  touched,
  errors,
}: Props) => {
  if (!products) return null;

  return (
    <Products
      fieldId={id}
      value={value}
      products={products}
      onChange={async (val) => {
        await setFieldValue(id, val, true);
        await setFieldTouched(id, true, true);
      }}
      readOnlyMode={readOnlyMode}
      culture={culture}
      fieldProperties={fieldProperties}
      errorComponent={(productId) => (
        <Feedback touched={touched} error={_.get(errors, `${id}.${productId}`)} name={productId} />
      )}
    />
  );
};

export default ProductsField;
